export default __webpack_public_path__ + "static/media/3docs.94fd8a11.jpg";